import { BaseEnum } from "./baseEnum";

const listNineBoxAxiosTypeEnum: Array<NineBoxAxiosTypeEnum> = [];

export type NineBoxAxiosType = "Potential" | "Performance";

export class NineBoxAxiosTypeEnum extends BaseEnum {
	static Potential = new NineBoxAxiosTypeEnum(
		1,
		"Potential",
		"Potencial",
		"trending-up"
	);
	static Performance = new NineBoxAxiosTypeEnum(
		2,
		"Performance",
		"Desempenho",
		"chart-line"
	);

	constructor(
		public id: number,
		public value: string,
		public label: string,
		icon: string
	) {
		super(id, value, label, icon);
		listNineBoxAxiosTypeEnum.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listNineBoxAxiosTypeEnum;
	}
}